import { Menu, Dropdown, Spin, Modal } from 'antd';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MenuOutlined, FileTextOutlined, CopyOutlined, EditOutlined, SettingOutlined,
    ArrowRightOutlined, ArrowDownOutlined, PlusOutlined,
    HistoryOutlined, PlusCircleOutlined, DashboardOutlined, FolderOpenOutlined } from '@ant-design/icons';
import PortfolioRuleEngine from "../../RuleEngine";
import useClipboard from "../../../../hooks/useClipboard";
import { useGptResponses } from "../../../../hooks/useGptResponses";
import ResponseMessage from "../../../../SuperComponents/Gpt/ResponseMessage";
import usePortfolioActions from "../../usePortfolioActions";

/**
 * PortfolioRowMenu Component
 *
 * @param {function} onEdit - Function to handle the edit action
 * @param {object} portfolio - Portfolio object document
 * @returns {JSX.Element}
 * @constructor
 */
const PortfolioRowMenu = ({ onEdit, portfolio }) => {
    const userId = localStorage.getItem('uid');
    const navigate = useNavigate();

    const [loadingResponse, setLoadingResponse] = useState(false);
    const [showGptSummary, setShowGptSummary] = useState(false);

    const copyToClipboard = useClipboard();
    const { responseId, submitPrompt } = useGptResponses();
    const gptResponse = useSelector(state => state.gptApi.responses[responseId]);

    // Use the usePortfolioActions hook for handling portfolio actions
    const { handlePortfolioAction } = usePortfolioActions({ portfolio });

    const portfolioUserId = portfolio?.attr?.create_uid;

    let rules = new PortfolioRuleEngine(portfolio);
    let isSMA = rules.isSMA();

    let menuItems = [
        {
            key: 'open',
            label: 'Open in New Tab',
            icon: <ArrowRightOutlined />,
            onClick: () => window.open(`/public/portfolio/${portfolio.id}`),
        },
        {
            key: 'view',
            label: 'View in Page',
            icon: <ArrowDownOutlined />,
            onClick: () => navigate(`/portfolio/${portfolio.id}`),
        },
        {
            key: 'copy',
            label: "Copy ID",
            icon: <CopyOutlined />,
            onClick: () => copyToClipboard(portfolio.id),
        },
        {
            key: 'positions',
            label: 'Signal History',
            icon: <HistoryOutlined />,
            onClick: () => navigate(`/signals/${portfolio.id}/history`),
        },
        {
            key: 'sma',
            label: isSMA ? 'Edit SMA' : 'Create SMA',
            icon: <PlusOutlined />,
            onClick: () => handlePortfolioAction(isSMA ? 'editSma' : 'createSma'),
        },
        {
            key: 'factSheet',
            label: 'Fact Sheet',
            icon: <DashboardOutlined />,
            onClick: () => navigate(`/portfolio/${portfolio.id}/factsheet`),
        },
    ];

    if (portfolioUserId && portfolioUserId === userId) {
        menuItems.unshift(
            {
                key: 'updatePositions',
                label: 'Update Positions',
                icon: <SettingOutlined />,
                onClick: () => handlePortfolioAction('updatePositions'),
            },
            {
                key: "edits",
                label: "Edit",
                icon: <EditOutlined />,
                onClick: onEdit,
            }
        );
    }

    const menu = (
        <Menu>
            {menuItems.map(item => (
                <Menu.Item key={item.key} icon={item.icon} onClick={item.onClick}>
                    {item.label}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <>
            <Dropdown overlay={menu} trigger={['click']}>
                <MenuOutlined style={{ fontSize: '18px' }} />
            </Dropdown>
            <Modal open={showGptSummary} onCancel={() => setShowGptSummary(false)}>
                {loadingResponse && <div style={{ padding: '40px' }}>
                    <Spin /> Loading Response
                </div>}
                {gptResponse?.data && <ResponseMessage response={gptResponse} />}
            </Modal>
        </>
    );
};

export default PortfolioRowMenu;